/**
 * The one transition used by every interactive element on the assemblies page.
 *
 * A single easing curve is what makes a page of unrelated controls — buttons, cells, chips,
 * table rows — feel like one surface. The curve is slow out of the gate and long on the tail,
 * so a hover reads as a settle rather than a snap. `motion-reduce` drops it entirely.
 */
export const MOTION = 'transition-all duration-300 ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:transition-none';

/** The same curve for the longer reveal, where the duration is set by the caller. */
export const MOTION_EASE = 'ease-[cubic-bezier(0.32,0.72,0,1)]';
